<template>
  <!-- v-click-outside="close" -->
  <div
    class="context-menu"
    v-show="show"
    :style="style"
    tabindex="-1"
    @contextmenu.capture.prevent
    @blur="close"
  >
    <ul>
      <slot :contextData="contextData" />
    </ul>
  </div>
</template>

<script>
// import ClickOutsideDirective from '@/directives/ClickOutside.directive';

export default {
  data() {
    return {
      left: 0,
      top: 0,
      show: false,
      contextData: {},
    };
  },

  // directives: {
  //   'click-outside': ClickOutsideDirective,
  // },

  computed: {
    //* get position of context menu
    style() {
      return {
        top: `${this.top}px`,
        left: `${this.left}px`,
      };
    },
  },

  methods: {
    close() {
      this.show = false;
      this.left = 0;
      this.top = 0;
    },

    open(evt, contextData, altUser = false, isLicenseID = false) {
      this.left = (evt.pageX || evt.clientX) + 5;
      // this.top = (evt.pageY || evt.clientY) + 5;
      this.top = (evt?.y ?? 0) + 5;
      this.contextData = { ...contextData, altUser, isLicenseID };

      this.$nextTick(() => {
        return this.$el.focus();
      });
      this.show = true;
    },
  },
};
</script>

<style lang="css" scoped>
.context-menu {
  position: fixed;
  z-index: 999;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}

.context-menu:focus {
  outline: none;
}

.context-menu ul {
  padding: 0px;
  margin: 0px;
}
</style>
